module.exports = __webpack_public_path__ + "img/workspace-onboarding/install-loom-ios-40618d7fd0878499ee125d65529b42fe.png";